import request from '@/utils/request'

// not implemented.
export function fetchList(data) {
  return request({
    url: '/Diary/ListCourseComment',
    method: 'post',
    data,
  })
}

export function fetchCourseComment() {
  return [
    {
      id: 1,
      description: 'Excellent',
      value: 4,
      itemValue: 1,
      itemName: `${1}`,
      label: 'Excellent',
    }, {
      id: 2,
      description: 'Good',
      value: 3,
      itemValue: 2,
      itemName: `${2}`,
      label: 'Good',
    }, {
      id: 3,
      description: 'Fair',
      value: 2,
      itemValue: 3,
      itemName: `${3}`,
      label: 'Fair',
    }, {
      id: 4,
      description: 'Poor',
      value: 1,
      itemValue: 4,
      itemName: `${4}`,
      label: 'Poor',
    }]
}

export function fetchWorkoutType() {
  return [
    {
      id: 1,
      description: 'Heavy',
      value: 3,
      itemValue: 1,
      itemName: `${1}`,
      label: 'Heavy',
    },
    {
      id: 2,
      description: 'Medium',
      value: 2,
      itemValue: 2,
      itemName: `${2}`,
      label: 'Medium',
    },
    {
      id: 3,
      description: 'Poor',
      value: 1,
      itemValue: 3,
      itemName: `${3}`,
      label: 'Poor',
    }]
}
